<template>
    <div class="container-click-sign">
        <section class="sign-required">
            <span class="sign-required-header">
                Assinaturas Requeridas
            </span>

            <span class="sign-required-configuration-default">
                Configure o padrão de assinatura para os contratos informando os tipos de usuários seus
                respectivos papeis no fluxo de assinatura.
            </span>
        </section>

        <section class="container-marker-paper-signers">
            <div class="marker-paper-signers">
                <section class="content-marker-paper-signers">
                    <div class="signers">
                        <span>Assinantes</span>
                    </div>

                    <div class="maker-paper">
                        <span class="paper">Papel</span>

                        <span class="proff-identity">Prova de Identidade</span>

                        <span class="can-refuse">Pode Recusar?</span>

                        <span class="receive-for-whatsapp">
                            Receber por WhatsApp?
                            <ui-tooltip-icon text="Selecione esta opção para receber o contrato pelo WhatsApp em vez de e-mail." link="https://ajuda.clicksign.com/article/785-assinando-via-whatsapp" size="sm"/>
                        </span>
                    </div>
                </section>

                <section class="draggable">
                    <draggable
                        :list="signers"
                        class="list-group"
                        ghost-class="ghost"
                        :animation="200"
                        @start="dragging = true"
                        @end="dragging = false"
                        @change="setSigners(signers)"
                    >
                        <div
                            v-for="(signer, index) in signers"
                            :key="index"
                            class="news-signers"
                        >
                            <div class="news-signers-items">
                                <div class="draggables">
                                    <div class="drag-image" data-ui="button-move-signer-position">
                                        <img :src="require('@/assets/imgs/drag-and-drop.svg')" />
                                    </div>

                                    <div class="checkbox">
                                        <ui-checkbox
                                            v-model="signer.selected"
                                            design="mgb-0"
                                            :checked="signer.selected"
                                            :disabled="signer.type === 'customer'"
                                        />
                                    </div>

                                    <div class="text-signers">
                                        <span>{{ signer.label }}</span>
                                    </div>

                                    <span v-if="signer.group === 'nonuser'" class="director">
                                        ({{ signer.name }} - {{ signer.email }})
                                    </span>
                                </div>

                                <div class="action-select-switch">
                                    <div class="action-select">
                                        <ui-select-v2
                                            v-model="signer.role"
                                            return-value="value"
                                            background-color="#FFF"
                                            design="mgb-0"
                                            size="md"
                                            disabled
                                            :data="roleOptions"
                                            :error="!!formValidation.errors[signer.group]?.role"
                                            :observation="formValidation.errors[signer.group]?.role"
                                        />
                                    </div>

                                    <div class="action-select">
                                        <ui-select-v2
                                            v-model="signer.auth"
                                            return-value="value"
                                            background-color="#FFF"
                                            size="md"
                                            design="mgb-0"
                                            :data="authOptions"
                                            :error="!!formValidation.errors[signer.group]?.auth"
                                            :observation="formValidation.errors[signer.group]?.auth"
                                        />
                                    </div>

                                    <div class="action-switch">
                                        <ui-switch
                                            v-model="signer.refusable"
                                            design="sm mgb-0"
                                            :checked="signer.refusable"
                                        />
                                    </div>

                                    <div class="action-switch">
                                        <ui-switch
                                            v-if="signer?.communicate_events?.signature_request"
                                            v-model="signer.communicate_events.signature_request"
                                            :checked="signer?.communicate_events?.signature_request === 'whatsapp'"
                                            value-true="whatsapp"
                                            value-false="email"
                                            design="sm mgb-0"
                                        />
                                    </div>

                                    <div v-if="signer.type === 'nonuser'" class="action-menu-card">
                                        <ui-menu-card icon="far fa-ellipsis-v">
                                            <button @click="edit(signer)">
                                                Configurações
                                            </button>

                                            <ui-button @click="removeSigner(index)">
                                                Excluir
                                            </ui-button>
                                        </ui-menu-card>
                                    </div>
                                </div>
                            </div>

                            <div v-if="hasErrors(signer)" class="errors-list">
                                <ul>
                                    <li
                                        v-for="(error, index) in formValidation.errors[signer.group]"
                                        :key="index"
                                    >
                                        {{ error }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </draggable>
                </section>
            </div>

            <div class="add-new-signers">
                <span class="new-signers" @click="addSigner">
                    + Adicionar novo assinante
                </span>
            </div>
        </section>

        <section class="footer-click-sign">

			<div class="data-signers-required">
                <div class="signers-required">
                    <span class="title-signers">Assinatura simultânea</span>

                    <span class="subtitle-signers">
                       	Por padrão, os assinantes recebem a solicitação um de cada vez, seguindo a ordem definida acima.
                    </span>
                </div>

                <div class="data-select">
                    <ui-switch
                        v-model="envelopeAttributes.send_simultaneous"
                        design="sm mgb-0"
                        :checked="envelopeAttributes.send_simultaneous"
                    />
                </div>
            </div>

            <div class="data-signers-required">
                <div class="signers-required">
                    <span class="title-signers">Dados obrigatórios</span>

                    <span class="subtitle-signers">
                        Define os campos de CPF e Data de Nascimento do assinante, como obrigatórios.
                    </span>
                </div>

                <div class="data-select">
                    <ui-switch
                        v-model="envelopeAttributes.has_documentation"
                        design="sm mgb-0"
                        :checked="envelopeAttributes.has_documentation"
                    />
                </div>
            </div>

            <div class="data-signers-required">
                <div class="signers-required">
                    <span class="title-signers">Lembrete de Assinatura</span>

                    <span class="subtitle-signers">Com que frequência você gostaria de notificar os assinantes sobre suas assinaturas pendentes?</span>
                </div>

                <div class="data-select">
                    <ui-select-v2
                        v-model="envelopeAttributes.remind_interval"
                        return-value="label"
                        size="lg"
                        placeholder="Selecione quantos dias..."
                        design="mgb-0"
                        :data="remindIntervalOptions"
                    />
                </div>
            </div>

            <div class="data-signers-required">
                <div class="signers-required">
                    <span class="title-signers">Tempo limite para Assinatura</span>

                    <span class="subtitle-signers">A partir da data de solicitação das assinaturas, quantos dias os assinantes tem para assinar o documento?</span>
                </div>

                <div class="data-select">
                    <ui-input-number
                        v-model="envelopeAttributes.deadline_at"
                        size="lg mgb-0"
                        :max-value="90"
                    />
                </div>
            </div>

            <div class="data-signers-required-switch">
                <div class="signers-required">
                    <span class="title-signers">Fechar Envelope automaticamente</span>

                    <span class="subtitle-signers">Impossibilita a adição de novos assinantes após todos os assinantes definidos assinar o documento</span>
                </div>

                <div class="data-select">
                    <ui-switch
                        v-model="envelopeAttributes.auto_close"
                        design="sm mgb-0"
                        :checked="envelopeAttributes.auto_close"
                    />
                </div>
            </div>

            <div class="data-signers-required-textarea">
                <div class="signers-required">
                    <span class="title-signers">Mensagem Padrão <span class="label-required">*</span></span>

                    <span class="subtitle-signers">
                        Defina uma mensagem padrão que os assinantes receberão no convite para assinatura do documento?
                    </span>
                </div>

                <div class="data-select">
                    <ui-textarea
                        v-model="envelopeAttributes.default_message"
                        placeholder="Digite uma mensagem..."
                    />
                </div>
            </div>

            <div class="save-editions">
                <ui-button
                    :disabled="!canSubmit"
                    design="primary mw-150 md"
                    @click="save"
                >
                    Salvar Alterações
                </ui-button>
            </div>
        </section>

        <ui-add-signers-modal
            :has-documentation="envelopeAttributes.has_documentation"
            mode="click_sign"
        />

        <ui-integration-modal />
    </div>
</template>

<script>
    import {
        uiSelectV2,
        uiCheckbox,
        uiSwitch,
        uiTextarea,
        uiInputNumber
    } from '@/components/ui/form'
    import { uiMenuCard, uiTooltipIcon } from '@/components/ui'
    import { uiButton } from '@/components/ui/buttons'
    import { uiAddSignersModal } from '@/components/ui-facilita/products'
    import uiIntegrationModal from './components/integration-modal'
	import draggable from 'vuedraggable'

    import { mapActions, mapGetters } from 'vuex'

    import { utilMixin } from '@/mixins'

    import { auths, clickRoles as roles } from '@/assets/js/data'

    export default {
        name: 'ui-click-sign',

        components: {
            uiSelectV2,
            uiCheckbox,
            uiMenuCard,
            uiButton,
            uiSwitch,
            uiAddSignersModal,
            uiTextarea,
            uiIntegrationModal,
            uiInputNumber,
			draggable,
			uiTooltipIcon
        },

        mixins: [utilMixin],

        data() {
            return {
                roleOptions: [...roles],
                authOptions: [...auths],
                remindIntervalOptions: [1, 2, 3, 7, 14],
                envelopeAttributes: {
                    has_documentation: false,
                    remind_interval: 1,
                    deadline_at: 5,
                    auto_close: false,
                    default_message: '',
                    locale: 'pt-BR',
                    block_after_refusal: false
                }
            }
        },

        computed: {
            ...mapGetters('digitalSignatureStore', {
                signers: 'getSigners',
                envelope: 'getEnvelope',
                formValidation: 'getFormValidation'
            }),
            /**
             * Computed property que verifica se a configuração de Assinantes possui todas as
             * informações necessárias
             */
            canSubmit() {
                return this.formValidation.valid && this.envelopeAttributes.default_message
            }
        },

        created() {
            /** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe(mutation => {
                if (mutation.type === 'digitalSignatureStore/SET_ENVELOPE' &&
                    this.envelope) {
                    this.envelopeAttributes = { ...this.envelope }
                }
            })
        },

        beforeDestroy() {
            this.unsubscribe()
        },

        methods: {
            ...mapActions('digitalSignatureStore',[
                'setSigners',
                'setEnvelope',
                'saveConfigs',
                'removeSigner'
            ]),
            /**
             * Abre o modal para o cadastro de assinantes externos
             */
			addSigner() {
				this.$root.$emit('modal-open-click_sign-add-signers')
			},
            /**
             * Abre o modal para edição de um assinante externo
             */
            edit(signer) {
                this.$root.$emit('modal-open-click_sign-add-signers', signer)
            },
            /**
             * Solicita o salvamento e registro dos dados de um envelop e seus
             * assinantes
             */
            save() {
                this.setEnvelope(this.envelopeAttributes)
                this.saveConfigs()
            },
            /**
             * Verifica se existem erros de formulário referentes a determinado assinante
             */
            hasErrors(signer) {
                return Object.keys(this.formValidation.errors[signer.group] || {}).length
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>